import React from "react"
import styled from "@emotion/styled"
import InnerHTML from "dangerously-set-html-content"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import ScrollEntrance from "src/components/ScrollEntrance"

import { mq, globals } from "src/styles"

const EmbedSection = styled(Section)`
  ${mq.largeAndBelow} {
    ${globals.verticalSpacing("padding-bottom")}
  }
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const EmbedWrapper = styled.div`
  width: 100%;
`

const EmbedCode = ({
  _key,
  className,
  width = "default",
  isFirstSection,
  theme,
  spacing,
  embedCode,
  prevTheme,
  nextTheme,
  hidden,
  hideMobile,
  hideDesktop,
}) => {
  if (hidden) return null

  const fullWidth = width === "fullWidth"

  return (
    <>
      <EmbedSection
        key={_key}
        className={className}
        setTheme={theme}
        prevTheme={prevTheme}
        nextTheme={nextTheme}
        isFirstSection={isFirstSection}
        padded={!fullWidth}
        vertical={spacing?.vertical}
        horizontal={spacing?.horizontal}
        hideMobile={hideMobile}
        hideDesktop={hideDesktop}
      >
        <Grid small="[1]" medium="m [1] m" large="[1]">
          <ScrollEntrance>
            <InnerHTML html={embedCode} />
          </ScrollEntrance>
        </Grid>
      </EmbedSection>
    </>
  )
}

export default EmbedCode
